/* eslint-disable camelcase */
import React, { FC, useEffect, useMemo, useState, memo, useRef } from "react"
import SyncableModel from "../../../../database/SyncableModel";
import moment from "moment";
import { Appearance, ScrollView } from "react-native"
import { CompositeScreenProps, useIsFocused } from "@react-navigation/native"
import { Feed } from "../../../../database"
import { FeedForm, ModelCreateScreen } from "../../../../components"
import { observer } from "mobx-react-lite"
import { useStores } from "../../../../models"
import { exitWalkthrough, startWalkthrough } from "react-native-walkthrough"
import formWalkthrough from "../../../../guides/form-walkthrough";
import { translate } from "../../../../i18n";

const FormWalkthrough: FC<{
  scrollViewRef?: { current: ScrollView }
}> = memo(observer(function FormWalkthrough(props) {
  const { scrollViewRef } = props
  const { userStore } = useStores()
  const { user } = userStore
  const isFocused = useIsFocused()

  useEffect(() => {
    if (!isFocused || !user || user?.state?.add_feed_coachmark_shown) return undefined
    startWalkthrough(formWalkthrough(
      [
        {
          id: 'feed-form',
          content: translate("feedForm.feedTooltip"),
          placement: 'top',
          tooltipProps: {},
        },
      ], () => {
        userStore.updateData({ state: { add_feed_coachmark_shown: true } })
          .finally(() => userStore.getUser())
        if (scrollViewRef && scrollViewRef.current)
          return scrollViewRef.current.scrollTo({ y: 0 })
      },
    ))
    return () => isFocused && exitWalkthrough();
  }, [isFocused, scrollViewRef, user, userStore])

  return null
}))

export const FeedCreateScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function FeedCreateScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params = {} } } = props

  // Pull in one of our MST stores
  const {
    appStore: { farmId, farmStore },
    feedStore: modelStore,
  } = useStores();

  const [ model, setModel ] = useState<SyncableModel>(null)
  const scrollViewRef = useRef<ScrollView>(null)

  const initialValues = useMemo<any>(() => {
    const data = (model ? model.toArray() : params)
    return {
      farm_id: farmId,
      ...data,
      logged_at: data.logged_at && moment.utc(data.logged_at).format('YYYY-MM-DD HH:mm:ss'),
      logged_date: data.logged_at && moment.utc(data.logged_at).format('YYYY-MM-DD'),
      logged_time: data.logged_at && moment.utc(data.logged_at).format('HH:mm:ss')
    }
  }, [farmId, model, params])

  useEffect(() => {
    const feed = farmStore.feeds.find((m) => m.id === params.id);
    if (feed) {
      const model = Feed.hydrate({ ...feed })
      setModel(model)
    }
  }, [farmStore, params.id, setModel])

  return (<>
    <ModelCreateScreen
      colorScheme={colorScheme}
      ModelForm={FeedForm}
      initialValues={initialValues}
      modelStore={modelStore}
      model={model}
      scrollViewRef={scrollViewRef}
    />
    <FormWalkthrough scrollViewRef={scrollViewRef} />
  </>)
})
